<template>
    <div class="container">
        <h1 class="py-5 mb-0">{{msg}}</h1>

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page">Home</li>
            </ol>
        </nav>

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">Library</li>
            </ol>
        </nav>

        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item"><a href="#">Library</a></li>
                <li class="breadcrumb-item active" aria-current="page">Data</li>
            </ol>
        </nav>

    </div>
</template>

<script>
    export default {
        name: "Breadcrumb",
        data() {
            return {
                msg: 'Breadcrumb'
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables";

    .breadcrumb {
        background-color: transparent;

        .breadcrumb-item {
            > a {
                color: $alert-blue;
            }

            &.active {
                color: #fff;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Breadcrumb.vue